import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "px-6 py-2 bg-gray-50"
};
const _hoisted_3 = {
  class: "flex flex-row bg-gray-100 shadow-md"
};
const _hoisted_4 = {
  class: "py-8 px-10"
};
const _hoisted_5 = {
  class: "block pb-8"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "flex flex-row"
};
const _hoisted_9 = {
  class: "flex justify-center align-center rounded-lg border-0 mx-4 my-4 relative"
};
const _hoisted_10 = {
  class: "m-5"
};
const _hoisted_11 = {
  key: 2,
  class: "fixed inset-0 z-[1000] flex items-start justify-center bg-black/30 overflow-auto p-6 pt-16"
};
import { onMounted, reactive, computed } from 'vue';
import RouteService from '@/services/RouteService';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTabs from '@/components/LlTabs.vue';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore.js';
import MaxioCompanySubscriptionPlan from './MaxioCompanySubscriptionPlan.vue';
import MaxioCompanySubscriptionInvoice from './MaxioCompanySubscriptionInvoice.vue';
import MainHeader from '@/components/MainHeader.vue';
import VerifyBankAccountModel from './VerifyBankAccountModel.vue';
import MaxioSubscriptionSummary from './MaxioSubscriptionSummary.vue';
import PlanSelection from '@/modules/onboarding/components/PlanSelection.vue';
export default {
  __name: 'MaxioCompanySubscription',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const subscriptionTabs = [{
      value: 1,
      label: 'Plan'
    }, {
      value: 2,
      label: 'Payment Method'
    }, {
      value: 3,
      label: 'Invoices'
    }];
    const companySubscriptionState = reactive({
      loading: false,
      subscription: {},
      isSmallScreen: false,
      me: {},
      cardColor: '#F3F4F6',
      openVerifyBankAccountModel: false,
      routeService: {},
      showPlanSelection: false
    });
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;

    // Mounted
    onMounted(async () => {
      companySubscriptionState.loading = true;
      companySubscriptionState.me = await props.userService.getMe();
      companySubscriptionState.routeService = new RouteService(props);
      companySubscriptionState.isSmallScreen = companySubscriptionState.routeService?.state?.params?.isSmallScreen ? true : false;
      await loadSubscription();
      companySubscriptionState.loading = false;

      // If the company has no selected product yet, open the plan selection overlay
      if (!companySubscriptionState.subscription?.product && !companySubscriptionState.isSmallScreen) {
        companySubscriptionState.showPlanSelection = true;
      }
    });
    const isActiveSubscription = computed(() => {
      return maxioCompanySubscriptionStore.isActiveSubscription;
    });
    const loadSubscription = async () => {
      companySubscriptionState.loading = true;
      companySubscriptionState.subscription = await maxioCompanySubscriptionStore.getSubscription();
      companySubscriptionState.loading = false;
      if (!companySubscriptionState.subscription?.email) {
        companySubscriptionState.subscription.email = companySubscriptionState.me.email;
      }
      if (companySubscriptionState.subscription.plan && companySubscriptionState.subscription?.plan?.description) {
        companySubscriptionState.subscription.plan.description = companySubscriptionState.subscription?.plan?.description.replace(/\n/g, '<br/>');
      }
    };
    const updatePaymentInformation = async () => {
      window.location.href = companySubscriptionState.subscription?.selfServicePaymentUrl;
    };
    const subscriptionStarted = async () => {
      await props.userService.reload();
      props.state.go('settings.company.maxioCompanySubscription');
      window.location.reload();
    };
    const openVerifyBankAccountModel = () => {
      if (!companySubscriptionState.openVerifyBankAccountModel) {
        companySubscriptionState.openVerifyBankAccountModel = true;
      }
    };
    const cancelVerifyBankAccountModel = () => {
      companySubscriptionState.openVerifyBankAccountModel = false;
    };
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_window_item = _resolveComponent("v-window-item");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_window = _resolveComponent("v-window");
      return _openBlock(), _createElementBlock(_Fragment, null, [companySubscriptionState.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_progress_circular, {
        color: "success",
        indeterminate: ""
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(MainHeader, {
        content: "LeanLaw Subscription"
      }), isActiveSubscription.value ? (_openBlock(), _createBlock(LlTabs, {
        key: 0,
        modelValue: companySubscriptionState.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => companySubscriptionState.tab = $event),
        items: subscriptionTabs,
        density: "default"
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_v_window, {
        modelValue: companySubscriptionState.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => companySubscriptionState.tab = $event),
        variant: "tonal"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_window_item, {
          value: 1,
          class: "window-item",
          variant: "tonal"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_container, {
            fluid: ""
          }, {
            default: _withCtx(() => [isActiveSubscription.value ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: _normalizeClass({
                    'text-center': companySubscriptionState.isSmallScreen
                  })
                }, [_createVNode(MaxioSubscriptionSummary, {
                  subscription: companySubscriptionState.subscription
                }, null, 8, ["subscription"])], 2)]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_v_container, {
            fluid: ""
          }, {
            default: _withCtx(() => [_createVNode(MaxioCompanySubscriptionPlan, {
              subscription: companySubscriptionState.subscription,
              alerts: __props.alerts,
              userService: __props.userService,
              state: __props.state,
              stateParams: __props.stateParams,
              isSmallScreen: companySubscriptionState.isSmallScreen,
              onSubscriptionStarted: subscriptionStarted
            }, null, 8, ["subscription", "alerts", "userService", "state", "stateParams", "isSmallScreen"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_window_item, {
          value: 2,
          class: "window-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_container, {
            fluid: ""
          }, {
            default: _withCtx(() => [companySubscriptionState?.subscription?.bank || companySubscriptionState?.subscription?.card ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
                  class: _normalizeClass({
                    'text-center': companySubscriptionState.isSmallScreen
                  })
                }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [companySubscriptionState?.subscription?.card ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("strong", null, "Card Information:", -1)), _createTextVNode(" " + _toDisplayString(companySubscriptionState?.subscription?.card?.description), 1)])])) : _createCommentVNode("", true), companySubscriptionState?.subscription?.bank ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", null, [_cache[4] || (_cache[4] = _createElementVNode("strong", null, "Bank Information:", -1)), _createTextVNode(" " + _toDisplayString(companySubscriptionState?.subscription?.bank?.description), 1)])])) : _createCommentVNode("", true)]),
                  _: 1
                }), _createVNode(_component_v_card_actions, {
                  class: "justify-start"
                }, {
                  default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                    class: "w-52",
                    onClick: updatePaymentInformation
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Update Payment Method ", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                })])])], 2), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [companySubscriptionState?.subscription?.bank && !companySubscriptionState?.subscription?.isAchVerified ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "warning",
                  dense: "",
                  text: "",
                  class: "flex"
                }, {
                  default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("span", null, "Proceed by entering deposit amounts to complete the process.", -1)), _createElementVNode("strong", {
                    text: "",
                    class: "text-decoration-underline cursor-pointer",
                    onClick: openVerifyBankAccountModel
                  }, " Enter Deposit Amounts ")]),
                  _: 1
                })) : _createCommentVNode("", true)])])])]),
                _: 1
              })]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_v_row, {
              key: 1
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(LlSecondaryButton, {
                color: "primary",
                class: "w-52",
                onClick: updatePaymentInformation
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Add Payment Method ", -1)]))]),
                _: 1
              })])]),
              _: 1
            }))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_window_item, {
          value: 3,
          class: "window-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_container, {
            fluid: ""
          }, {
            default: _withCtx(() => [_createVNode(MaxioCompanySubscriptionInvoice, {
              subscription: companySubscriptionState.subscription,
              alerts: __props.alerts,
              isSmallScreen: companySubscriptionState.isSmallScreen
            }, null, 8, ["subscription", "alerts", "isSmallScreen"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), companySubscriptionState.openVerifyBankAccountModel ? (_openBlock(), _createBlock(VerifyBankAccountModel, {
        key: 1,
        alerts: __props.alerts,
        onCancel: cancelVerifyBankAccountModel
      }, null, 8, ["alerts"])) : _createCommentVNode("", true)])), companySubscriptionState.showPlanSelection ? (_openBlock(), _createElementBlock("div", _hoisted_11, [companySubscriptionState.showPlanSelection ? (_openBlock(), _createBlock(PlanSelection, {
        key: 0,
        onCancel: _cache[2] || (_cache[2] = $event => companySubscriptionState.showPlanSelection = false)
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
    };
  }
};